'use client';

import Image from 'next/image';
import { PolyGrid } from '../../../public/images';
import { SidebarTrigger } from '../ui/sidebar';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import { CustomBreadcrumb } from './CustomBreadcrumb';

interface AppHeaderProps {
  title?: string;
  subtitle?: string;
  hasBreadcrumb?: boolean;
  hasGridPattern?: boolean;
  className?: string;
  titleClass?: string;
}

const AppHeader = ({
  title,
  subtitle,
  hasBreadcrumb = false,
  hasGridPattern = false,
  className,
  titleClass,
}: AppHeaderProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={cn(className)}>
      <div>
        {hasBreadcrumb && (
          <div className='flex items-center gap-2'>
            {isMobile && <SidebarTrigger />}

            <CustomBreadcrumb />
          </div>
        )}

        <div className='flex justify-between items-center gap-[3.75rem] w-full'>
          <div className={cn('flex flex-col items-start gap-3', titleClass)}>
            {title && (
              <h1 className='font-semibold text-black text-[2rem] leading-none'>
                {title}
              </h1>
            )}

            {subtitle && <p className='text-[#47536C] text-sm'>{subtitle}</p>}
          </div>

          {hasGridPattern && (
            <div className='relative w-[83%] h-[9.9375rem] inline-flex justify-end'>
              <Image
                src={PolyGrid}
                alt=''
                className='w-max-full h-auto absolute object-cover bg-no-repeat'
                fill
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
